module.exports = __webpack_public_path__ + "img/logout.265b9530.svg";